var styles = {"scrim":"OverlayScrim-module_scrim__8i7A8"};

export { styles as default };
